/**
 * Emit hosts for the `contact` analytics group — 1 function
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';

/**
 * Track contact sales form submitted event
 * Fired when a contact sales form is submitted
 */
export function trackContactSalesFormSubmitted(input: { form_id: string }) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ContactSalesFormSubmitted,
    props: {
      form_id: input.form_id,
    },
  });
}
